import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import Header from '../components/Header';

import Footer from '../components/Footer';
import SEO from '../components/SEO';
import blogPosts from '../data/blogPosts';

const categoryColors = {
  'Revenue Intelligence': 'bg-blue-50 text-blue-700',
  'Product Vision': 'bg-purple-50 text-purple-700',
  'Sales Strategy': 'bg-emerald-50 text-emerald-700',
  'Industry Analysis': 'bg-amber-50 text-amber-700',
  'Sales Playbook': 'bg-rose-50 text-rose-700',
};

export default function Blog() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <SEO
        title="Blog - Revenue Intelligence Insights"
        description="Thoughts on revenue operations, sales productivity, dashboard fatigue, and AI tools from the team building the Revenue OS. No fluff, just signal."
        path="/blog"
      />
      <main className="pt-44 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="mb-12">
            <p className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-2">Forsyt Blog</p>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
              Thoughts on revenue, action, and what sales teams actually need
            </h1>
            <p className="text-base text-gray-500 max-w-2xl">
              Insights from the team building the Revenue OS. No fluff, just signal.
            </p>
          </div>

          <div className="space-y-0 divide-y divide-gray-100" data-testid="blog-list">
            {blogPosts.map((post, index) => (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className="group block py-8 first:pt-0"
                data-testid={`blog-card-${index}`}
              >
                <div className="flex items-start justify-between gap-6">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3 mb-2.5">
                      <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${categoryColors[post.category] || 'bg-gray-50 text-gray-600'}`}>
                        {post.category}
                      </span>
                      <span className="flex items-center gap-1 text-xs text-gray-400">
                        <Clock className="w-3 h-3" />
                        {post.readTime}
                      </span>
                    </div>
                    <h2 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-200 mb-1.5">
                      {post.title}
                    </h2>
                    <p className="text-sm text-gray-500 leading-relaxed line-clamp-2">
                      {post.excerpt}
                    </p>
                    <p className="text-xs text-gray-400 mt-2">{post.date}</p>
                  </div>
                  <ArrowRight className="w-5 h-5 text-gray-300 group-hover:text-blue-600 group-hover:translate-x-1 transition-all duration-200 mt-3 flex-shrink-0" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
